// A contact row in the inbox covers every channel the customer writes on; it
// is marked as handed off when any of them is.
export function isContactHandedOff(conv) {
  return Boolean(conv?.channelMeta?.some(meta => meta.handed_off))
}

// The chatbot button in a thread shows whether the bot is actually replying
// there — not just whether staff switched AI off. A handoff silences the bot
// too, so the button reads "off" for it as well.
export function isBotReplying({ aiEnabled, handedOff }) {
  return Boolean(aiEnabled) && !handedOff
}

// What pressing that button should do. `setAiEnabled` is null when the AI
// toggle should be left as it is.
export function botToggleAction({ aiEnabled, handedOff }) {
  if (isBotReplying({ aiEnabled, handedOff })) {
    return { resumeHandoff: false, setAiEnabled: false }
  }
  return {
    resumeHandoff: Boolean(handedOff),
    setAiEnabled: aiEnabled ? null : true,
  }
}
